import TrainOrderInteractor from '@/business/Domain/use-cases/train-order-interactor'

export default {
  data() {
    return {
      canSubmit: false,
    }
  },
  methods: {
    /**
     * 申请退改页 的账号核验
     */
    async validAccount(id) {
      const {data} = await TrainOrderInteractor.getDetailById(id)

      let params = {
        password: data.password,
        userName: data.trainAccount
      }

      if (data.productType == 1) {
        this.$api['trQuery/12306Login'](params).then(res => {
          if (res.data == 1) {
            this.canSubmit = true
          } else {
            this.$dialog({message: '当前账户需要重新核验，通过后才能申请退改签。可进入订单详情或登录“铁路12306”APP进行核验。'})
          }
        }).catch(err => {
          if (err.errCode == '239001') {
            this.$toast.clear()

            this.$dialog({message: '当前账户需要重新核验，通过后才能申请退改签。可进入订单详情或登录“铁路12306”APP进行核验。'})
          } else if (err.errCode == '239002' || err.errCode == '239003') {
            this.$toast.clear()

            this.$toast({
              icon: 'user-o',
              message: '当前账户需要重新进行人脸核验，通过后才能申请退改签。可进入订单详情或登录“铁路12306”APP进行人脸核验。'
            })
          }
        })
      } else {
        this.canSubmit = true
      }
    },
  }
}
